import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiBook, FiCalendar, FiMapPin } = FiIcons;

const Education = ({ data }) => {
  return (
    <section className="py-20 px-6">
      <div className="container mx-auto max-w-6xl">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl lg:text-5xl font-bold text-stone-800 mb-6">
            Education
          </h2>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          <div className="space-y-8">
            {data.map((edu, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, x: -30 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.6, delay: 0.4 + index * 0.2 }}
                className="bg-white rounded-2xl p-8 border border-stone-200 shadow-lg"
              >
                <div className="flex flex-wrap items-start justify-between mb-4">
                  <div>
                    <h4 className="text-2xl font-bold text-stone-800 mb-2">{edu.degree}</h4>
                    <h5 className="text-xl text-amber-700 font-semibold mb-2">{edu.specialization}</h5>
                    <h6 className="text-lg text-stone-600 mb-2">{edu.school}</h6>
                  </div>
                  <div className="flex flex-col items-end space-y-2">
                    <div className="flex items-center space-x-2 text-stone-500">
                      <SafeIcon icon={FiCalendar} className="text-sm" />
                      <span className="text-sm">{edu.period}</span>
                    </div>
                    <div className="flex items-center space-x-2 text-stone-500">
                      <SafeIcon icon={FiMapPin} className="text-sm" />
                      <span className="text-sm">{edu.location}</span>
                    </div>
                    <div className="bg-stone-100 px-3 py-1 rounded-lg">
                      <span className="text-stone-700 text-sm font-semibold">GPA: {edu.gpa}</span>
                    </div>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Education;